import styled from "styled-components";
import { Flex, Grid } from "../../common/Layouts/styles";
import {
  CTAColor,
  buttonColor,
  fadingTextColor,
  secondaryColor,
  thirdColor,
} from "../../styles/styles";
import { StyledCTAButton } from "../../common/CTAButton/styles";
import { FlexWrap } from "../MainBlock/styles";
import { StyledTag } from "../../common/Tag/styles";

export const Container = styled("div")`
  align-self: start;
  background-color: ${secondaryColor};
  padding: 2vw;
`;

export const Title = styled("h2")`
  margin-bottom: 1.2vw;
  color: ${CTAColor};
  font-weight: 400;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 10em;
    margin-bottom: 5vw;
  }
`;

export const FlexContainer = styled(Flex)`
  gap: 3rem;
  height: 100%;
  margin-top: 1rem;
`;

export const Description = styled("span")`
  color: ${fadingTextColor};
  align-self: flex-end;
  margin-bottom: 3rem;
`;

export const ButtonContainer = styled(Flex)`
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
`;

export const Button = styled("button")`
  border: none;
  background-color: ${buttonColor};
  white-space: nowrap;
  padding: 0.5rem;
  -webkit-box-shadow: -4px 4px 0px 0px rgba(45, 70, 145, 0.8);
  -moz-box-shadow: -4px 4px 0px 0px rgba(45, 70, 145, 0.8);
  box-shadow: -4px 4px 0px 0px rgba(45, 70, 145, 0.8);
`;

export const DevContainer = styled("div")`
  margin-top: 2rem;
`;

export const GoodsGrid = styled(Grid)`
  grid-template-columns: 3fr 1fr;
  gap: 0.6vw;
`;

export const CardInner = styled(Flex)`
  position: relative;
  transition: transform 0.54s ease-in-out;
  transform-style: preserve-3d;
  background-color: ${secondaryColor};
  border-radius: 8px;
`;

export const DevItemsContainer = styled(Flex)`
  position: relative;
  perspective: 1000px;
  min-width: 24vw;
  height: 123;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-width: 75vw;
  }

  /* &:hover ${CardInner} {
    transform: rotateY(180deg);
  } */
`;

export const LogoWrapper = styled(Flex)`
  justify-content: flex-end;
`;

export const FlexScroll = styled(Flex)`
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MiniTitle = styled("span")`
  position: relative;
  margin-left: 1rem;
  top: -0.75rem;
  padding: 0.125rem 0.5rem;
  border: 1px solid #ccc;
  font-size: 1vw;
`;

export const OrderNumber = styled("h4")`
  position: absolute;
  left: 2vw;
  top: 2vw;
  color: ${CTAColor};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    left: 4vw;
    top: 4vw;
    font-size: 4em;
  }
`;

export const DevItemsDescription = styled("p")`
  margin-top: 1vw;
  color: ${fadingTextColor};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 4em;
    padding: 2vw 1vw;
  }
`;

export const CTAButtonRow = styled(StyledCTAButton)`
  padding: 0.2vw 0.3vw;
`;

export const CTAFlexWrap = styled(FlexWrap)`
  font-size: 0.95em !important;
  margin-top: 1vw;
`;

export const GoodTag = styled(StyledTag)`
  align-self: stretch;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 3em;
    padding: 1vw;
  }
`;

export const GoodContactDescription = styled("h3")`
  color: ${fadingTextColor};
`;

export const AdditionalText = styled("p")`
  margin: 0;
`;

export const CardSide = styled("div")`
  /* position: absolute; */
  -webkit-perspective: 0;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  visibility: visible;
  backface-visibility: hidden;
`;

export const CardInfo = styled(Flex)`
  padding: 2vw;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 4vw;
  }
`;

export const GoodsContainer = styled(Flex)`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 4vw;
  }
`;

export const CardFront = styled(CardSide)`
  display: flex;
  flex-grow: 1;
  position: relative;
`;

export const CardBack = styled(CardSide)`
  transform: rotateY(180deg);
  position: absolute;
  padding: vw;
  top: 0;
`;

export const AdditionalItem = styled(Flex)`
  padding-left: 1vw;
  gap: 2vw;
  margin-top: 0.6vw;
`;

export const MiniTitleTag = styled("span")`
  background-color: ${thirdColor};
  color: white;
  padding: 0.4vw 0.6vw;
  align-self: flex-start;
  white-space: nowrap;
  font-weight: 500;
  border-radius: 8px;
`;

export const ItemTitle = styled("h2")`
  font-size: 1.03em;
  margin-bottom: 0.25rem;
`;

export const ItemDescription = styled("p")`
  color: ${fadingTextColor};
  font-size: 0.98em;
  line-height: 1vw;
`;

export const SvgWrapper = styled("div")`
  margin-top: 1vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 3vw;
  }
`;
